var _rect, _path, _path2, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoRegionalprioritiesgoals02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 88,
    viewBox: "0 0 85 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.1667,
    y: 25.5,
    width: 33,
    height: 42,
    fill: "#FF24A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6668 21.0833C51.6668 22.0917 50.8418 22.9167 49.8335 22.9167H35.1668C34.1585 22.9167 33.3335 22.0917 33.3335 21.0833V18.3333C33.3335 17.325 34.1585 16.5 35.1668 16.5H49.8335C50.8418 16.5 51.6668 17.325 51.6668 18.3333V21.0833Z",
    fill: "#450ADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1667 20.1665H27.8334C25.8167 20.1665 24.1667 21.8165 24.1667 23.8332V67.8332C24.1667 69.8498 25.8167 71.4998 27.8334 71.4998H57.1667C59.1834 71.4998 60.8334 69.8498 60.8334 67.8332V23.8332C60.8334 21.8165 59.1834 20.1665 57.1667 20.1665ZM57.1667 63.2498C57.1667 63.7082 56.7084 64.1665 56.2501 64.1665H28.7501C28.2917 64.1665 27.8334 63.7082 27.8334 63.2498V28.4165C27.8334 27.9582 28.2917 27.4998 28.7501 27.4998H56.2501C56.7084 27.4998 57.1667 27.9582 57.1667 28.4165V63.2498Z",
    fill: "#450ADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1667,
    y: 31.5,
    width: 21,
    height: 6,
    rx: 2,
    fill: "#450ADF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1667,
    y: 42.5,
    width: 21,
    height: 6,
    rx: 2,
    fill: "#450ADF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1667,
    y: 53.5,
    width: 21,
    height: 6,
    rx: 2,
    fill: "#450ADF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRegionalprioritiesgoals02);
export default __webpack_public_path__ + "static/media/ico_regionalprioritiesgoals_02.e9e9cf2eb95682f0bb251f5ceec57058.svg";
export { ForwardRef as ReactComponent };